var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":_vm.url,"title":"SoftlineAngola"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }